import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { Dialog } from "@mui/material";
import * as React from "react";

import { PageLayout } from "@/shared/components";
import { AddToCollection } from "@/shared/components/collections";
import { FilesList } from "@/shared/components/files";
import { type SelectionOption } from "@/shared/components/ResourceView";
import { FileRecord } from "@/shared/domain/files";
import { useDeleteFilesMutation } from "@/shared/domain/files/hooks";
import { usePopupState } from "@/shared/hooks/usePopupState";

export function FilesPage() {
  const { mutate: deleteFiles } = useDeleteFilesMutation();
  const addToCollectionPopup = usePopupState<Set<string>>();

  const selectionOptions = React.useMemo<SelectionOption<FileRecord>[]>(
    () => [
      {
        name: "Add to Collection",
        icon: <PlaylistAddIcon fontSize="small" />,
        action: ({ selected }) => {
          addToCollectionPopup.open({
            metadata: new Set(selected.map((f) => f.file_id)),
          });
        },
      },
      {
        name: "Delete files",
        icon: <DeleteOutlineIcon fontSize="small" />,
        action: ({ selected }) => {
          if (selected.length === 0) {
            return;
          }
          const ok = window.confirm(
            `Delete ${selected.length} file${selected.length === 1 ? "" : "s"}? This cannot be undone.`,
          );
          if (!ok) {
            return;
          }
          deleteFiles({
            fileIds: selected.map((file) => file.file_id),
            resourceOwnerId: selected[0].org_id,
          });
        },
      },
    ],
    [addToCollectionPopup, deleteFiles],
  );

  return (
    <PageLayout title="Roboto - Files" headerContentLeft="Files">
      <FilesList scope={{ type: "org" }} selectionOptions={selectionOptions} />
      <Dialog
        open={addToCollectionPopup.isOpen}
        onClose={addToCollectionPopup.close}
      >
        <AddToCollection
          selectedFileIds={addToCollectionPopup.metadata ?? new Set()}
          close={addToCollectionPopup.close}
        />
      </Dialog>
    </PageLayout>
  );
}
